import {PersonDto} from "./person.dto";
import {UserDto} from "./user.dto";
import {CompanyDto} from "./company.dto";
import { IsDate, IsEnum, IsNotEmpty, IsNumber, IsOptional, IsString } from 'class-validator';
import {Type} from "class-transformer";
import { EventTaskType, EventType } from "./enums/events";
import { PhoneDto } from "./contacts/phone";

export type ToggleEventDto = Pick<EventDto, 'completed'|'important'>

export interface WazzupMessageDto {
  messageId: string;
  dateTime: Date;
  chatId: string;
  chatType: string;
  channelId?: string;
  text?: string;
  status?: string;
  contentUri?: string;
  authorName?: string;
  contactName?: string;
}

export class EventDto {
  wazzupDay?: string;
  wazzupMessageCount?: number;
  wazzupCompanyId?: number;

  id: number;
  @IsEnum(EventType)
    type: EventType;
  @IsEnum(EventTaskType)
    taskType: EventTaskType;
  content: string;
  company: CompanyDto;
  createdDate: Date;
  dueDate?: Date;
  important: boolean;
  completed: boolean;
  contactPerson?: PersonDto;
  manager: UserDto;
  leadId?: number;
  atsAudioLink?: string;
  emailId?: number;
}

export class EventCallsDto extends EventDto {
  createdAt: Date;
  user?: UserDto;
  atsAudioLink?: string;
  atsDuration?: number;
  fromPhone?: PhoneDto;
  toPhone?: PhoneDto;
}

export class CreateEventDto {
  @IsOptional()
  @IsNotEmpty()
  @IsEnum(EventType)
  type?: EventType;

  @IsString()
  @IsNotEmpty()
  @IsEnum(EventTaskType)
  taskType?: EventTaskType;

  @IsString()
  @IsNotEmpty()
  content: string;

  @IsDate()
  @IsOptional()
  @Type(() => Date)
  dueDate?: Date;

  @IsOptional()
  @IsNumber()
  companyId?: number;

  @IsOptional()
  @IsNumber()
  contactPersonId?: number;

  @IsDate()
  @IsOptional()
  @Type(() => Date)
  createdAt?: Date;

  emailId?: number;
  
  leadId?: number;

  atsEntryId?: string;

  atsAudioLink?: string;

  wazzupMessageId?: string;

  atsDuration?: number;
  fromPhoneId?: number;
  toPhoneId?: number;
}
